import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { CookiesProvider } from 'react-cookie';
import { IntlProvider } from 'react-intl';

import 'bootstrap/dist/css/bootstrap.min.css';

import { CookieComponent } from './utils/Cookies';
import { I18nComponent } from './utils/I18n';
import AlertDialog from './utils/AlertDialog';

const zh_TW = require("./langs/zh-tw.json");

const locale = navigator.language;

//TODO : select lang file on multi langs
var messages = zh_TW;

ReactDOM.render(
  <CookiesProvider>
    <IntlProvider locale={locale} key={locale} messages={messages}>
      <CookieComponent />
      <I18nComponent />
      <AlertDialog />
      <App />
    </IntlProvider>
  </CookiesProvider>, 
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
